class PickupGuestDataController {
    constructor() {
        this.requestPending = false;
    }

    submitImmediate(form) {
        this.requestPending = true;
        form.$$element.submit();
    }
}

export default PickupGuestDataController;
